import { apiClient } from '@/api/client';
import { clearCsrfToken, setCsrfToken } from '@/api/csrf';
import { AuthBootstrapState } from '@/types/auth';
import { User } from '@/types/user';

type AuthBootstrapResponse = {
    data: AuthBootstrapState;
    csrfToken?: string;
};

type AuthLogoutResponse = {
    ok: boolean;
    logoutUrl: string;
};

type WelcomeScreenCompletion = {
    welcome_screen_completed: boolean;
    welcome_screen_completed_at: string | null;
};

type WelcomeScreenCompletionResponse = {
    data: WelcomeScreenCompletion;
};

const applyAuthResponse = (responseBody: AuthBootstrapResponse) => {
    setCsrfToken(responseBody.csrfToken);

    return responseBody.data;
};

export const authApi = {
    bootstrap: async (): Promise<AuthBootstrapState> => {
        const responseBody = (await apiClient.get<AuthBootstrapResponse>(
            '/auth/bootstrap',
        )) as unknown as AuthBootstrapResponse;

        return applyAuthResponse(responseBody);
    },
    logout: async (): Promise<AuthLogoutResponse> => {
        try {
            return (await apiClient.post<AuthLogoutResponse>(
                '/auth/logout',
            )) as unknown as AuthLogoutResponse;
        } finally {
            clearCsrfToken();
        }
    },
    login: async (): Promise<User> => {
        const responseBody = (await apiClient.get<{ data: User }>('/me')) as unknown as {
            data: User;
        };
        return responseBody.data;
    },
    signup: async (payload: {
        email?: string;
        full_name?: string;
        crp?: string;
        birth_date?: string;
        phone?: string;
        crp_state?: string;
    }): Promise<User> => {
        const responseBody = (await apiClient.post<{ data: User }>(
            '/signup',
            payload,
        )) as unknown as { data: User };
        return responseBody.data;
    },
    completeWelcomeScreen: async (): Promise<WelcomeScreenCompletion> => {
        const responseBody = (await apiClient.patch<WelcomeScreenCompletionResponse>(
            '/me/welcome-screen',
            { completed: true },
        )) as unknown as WelcomeScreenCompletionResponse;

        return responseBody.data;
    },
};
